import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/60 p-5 hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="flex items-center gap-2 mb-3">
          <span className="text-xs px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
            {getCategoryLabel(article.category)}
          </span>
          <span className="text-xs text-foreground-400">{article.date}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-400">{article.readTime}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-2">
          <span className="text-xs text-foreground-400">{article.author}</span>
          <span className="text-xs text-primary-500 font-medium flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            阅读全文 <i className="ri-arrow-right-line text-xs"></i>
          </span>
        </div>
      </Link>
    </article>
  );
}

function getCategoryLabel(slug: string): string {
  const map: Record<string, string> = {
    'liuman-video-dingyi': '流氓视频定义',
    'shibie-exing-shipin': '识别恶意视频',
    'fangfan-cuoshi': '防范措施',
    'jubao-weiquan': '举报维权',
  };
  return map[slug] || slug;
}